import React from 'react';
import userRoles from 'app/userRoles';

const DocumentationConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [
    userRoles.ROLE_SUPER_ADMIN,
    userRoles.ROLE_DOC_FILES_LIST,
    userRoles.ROLE_DOC_FILES_ADD,
    userRoles.ROLE_DOC_FILES_EDIT,
    userRoles.ROLE_DOC_FILES_SHOW,
    userRoles.ROLE_CUSTOMIZATION,
    userRoles.FRANCHISEE_LIBRARY_CONTENT_LIST
  ],
  routes: [
    {
      exact: true,
      path: '/documentation',
      component: React.lazy(() =>
        import('./documentation_layout/DocumentationLayout')
      )
    },
    {
      exact: true,
      path: '/documentation/customize/:id',
      component: React.lazy(() =>
        import('./documentation_customization/CustomizeEditor')
      )
    },
    {
      exact: true,
      path: '/documentation/customizations/requests',
      component: React.lazy(() =>
        import('./documentation_custom_requests/CustomRequestsList')
      )
    },
    {
      exact: true,
      path: '/documentation/customize/:id/requests/new',
      component: React.lazy(() => import('./custom-requests/create'))
    },
    {
      exact: true,
      path: '/documentation/customizations/requests/:id',
      component: React.lazy(() =>
        import('./documentation_custom_requests/CustomRequestDetail')
      )
    },
    {
      exact: true,
      path: '/documentation/files/create',
      component: React.lazy(() => import('./documentation_files/FileCreate'))
    },
    {
      exact: true,
      path: '/documentation/files/:id',
      component: React.lazy(() => import('./documentation_files/FileEdit'))
    }
  ]
};

export default DocumentationConfig;
